import { Component, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import getBoundsOfDistance from 'geolib/es/getBoundsOfDistance';

import { MapBoxService, Feature } from '@portals/api';

type Radius = { value: number; label: string };
type EmittedValue = { value: [string[], string[]]; isRange: boolean };
type BoundsOfDistance = { latitude: number; longitude: number };

@Component({
	selector: 'portals-map-autocomplete',
	templateUrl: './map-autocomplete.component.html',
	styleUrls: ['./map-autocomplete.component.scss'],
})
export class MapAutocompleteComponent {
	radiusOptions: Radius[] = [
		{ value: 8046.72, label: '5 miles' },
		{ value: 16093.4, label: '10 miles' },
		{ value: 40233.6, label: '25 miles' },
		{ value: 80467.2, label: '50 miles' },
	];
	selectedRadius: number = 0;
	addresses: Feature[] = [];
	selectedAddress: Feature | null = null;
	searchValueUpdate = new Subject<string>();
	@Output() onValueChange = new EventEmitter<EmittedValue>();

	constructor(private mapBoxService: MapBoxService) {
		this.searchValueUpdate.pipe(debounceTime(300), distinctUntilChanged()).subscribe((value: any) => {
			this.mapBoxService.searchKeyword(value).subscribe((features: any) => {
				this.addresses = features;
			});
		});
	}

	search(event: any) {
		const searchTerm = event.target.value.toLowerCase();
		if (searchTerm && searchTerm.length > 0) {
			this.searchValueUpdate.next(searchTerm);
		} else {
			this.addresses = [];
		}
	}

	handleValueChange() {
		if (this.selectedAddress) {
			const {
				geometry: { coordinates },
			} = this.selectedAddress || {};
			const [latitude, longitude] = coordinates || [];
			const locationCircumference: BoundsOfDistance[] = getBoundsOfDistance({ latitude, longitude }, this.selectedRadius);
			const mappedLatitude: string[] = locationCircumference.map(({ latitude }: BoundsOfDistance) => `${latitude}`);
			const mappedLongitude: string[] = locationCircumference.map(({ longitude }: BoundsOfDistance) => `${longitude}`);
			this.onValueChange.emit({
				value: [mappedLatitude, mappedLongitude],
				isRange: true,
			});
		}
	}

	onSelectRadius(radiusVal: number) {
		this.selectedRadius = radiusVal;
		this.handleValueChange();
	}

	onSelectLocation(address: Feature) {
		this.selectedAddress = address;
		this.addresses = [];
		this.handleValueChange();
	}
}
